import {
  Form,
  Select,
  Button,
  Input,
  message,
  Row,
  Col,
  Checkbox,
  Card,
  Space,
} from "antd";
import { useEffect, useState } from "react";
import api from "../../services/api";

export default function BulkProductCreate() {
  const [subcategories, setSubcategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [colors, setColors] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [form] = Form.useForm();
  const [selectedModels, setSelectedModels] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [modelSearch, setModelSearch] = useState("");
  const [colorSearch, setColorSearch] = useState("");
  useEffect(() => {
    loadSubcategories();
    loadBrands();
    loadModels();
    loadColors();
  }, []);

  const loadSubcategories = async () => {
    const res = await api.get("/catalog/subcategories");
    setSubcategories(res.data || []);
  };

  const loadBrands = async () => {
    const res = await api.get("/catalog/brands");
    setBrands(res.data || []);
  };

  const loadModels = async () => {
    const res = await api.get("/catalog/models");
    setModels(res.data || []);
  };

  const displayedModels = filteredModels.filter((m) =>
    m.name.toLowerCase().includes(modelSearch.toLowerCase()),
  );

  const displayedColors = colors.filter((c) =>
    c.value.toLowerCase().includes(colorSearch.toLowerCase()),
  );

  const handleBrandChange = (brandId) => {
    const filtered = models.filter((m) => m.brand_id === brandId);

    setFilteredModels(filtered);

    setSelectedModels([]);
  };

  const loadColors = async () => {
    const res = await api.get("/attributes");
    const colorAttr = res.data.find((a) => a.name === "Colors");
    setColors(colorAttr?.AttributeValues || []);
  };

  const handleSubmit = async (values) => {
    const payload = {
      subcategory_id: values.subcategory_id,
      brand_id: values.brand_id,
      model_ids: selectedModels,
      color_ids: selectedColors,
    };

    await api.post("/products/bulk-create", payload);

    message.success("Products generated successfully");

    form.resetFields();
    setSelectedModels([]);
    setSelectedColors([]);
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleSubmit}>
      <Row gutter={20}>
        {/* COLUMN 1 */}
        <Col span={8}>
          <Card title="Product Details" size="small">
            <Form.Item name="subcategory_id" label="Category">
              <Select
                options={subcategories.map((s) => ({
                  value: s.id,
                  label: s.name,
                }))}
              />
            </Form.Item>

            <Form.Item name="brand_id" label="Brand">
              <Select
                onChange={handleBrandChange}
                options={brands.map((b) => ({
                  value: b.id,
                  label: b.name,
                }))}
              />
            </Form.Item>
          </Card>
        </Col>
        {/* COLUMN 2 MODELS */}

        <Col span={8}>
          <Card
            title="Models"
            size="small"
            extra={
              <Button
                type="link"
                onClick={() => {
                  const visibleIds = displayedModels.map((m) => m.id);

                  if (visibleIds.every((id) => selectedModels.includes(id))) {
                    setSelectedModels((prev) =>
                      prev.filter((id) => !visibleIds.includes(id)),
                    );
                  } else {
                    setSelectedModels((prev) => [
                      ...new Set([...prev, ...visibleIds]),
                    ]);
                  }
                }}
              >
                {selectedModels.length === filteredModels.length
                  ? "Deselect All"
                  : "Select All"}
              </Button>
            }
          >
            <Input
              placeholder="Search model..."
              value={modelSearch}
              onChange={(e) => setModelSearch(e.target.value)}
              style={{ marginBottom: 10 }}
            />

            <Space direction="vertical" style={{ width: "100%" }}>
              {displayedModels.map((m) => (
                <Checkbox
                  key={m.id}
                  checked={selectedModels.includes(m.id)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedModels((prev) => [
                        ...new Set([...prev, m.id]),
                      ]);
                    } else {
                      setSelectedModels((prev) =>
                        prev.filter((id) => id !== m.id),
                      );
                    }
                  }}
                >
                  {m.name}
                </Checkbox>
              ))}
            </Space>
          </Card>
        </Col>

        {/* COLUMN 3 COLORS */}

        <Col span={8}>
          <Card
            title="Variants"
            size="small"
            extra={
              <Button
                type="link"
                onClick={() => {
                  const visibleIds = displayedColors.map((c) => c.id);

                  if (visibleIds.every((id) => selectedColors.includes(id))) {
                    setSelectedColors((prev) =>
                      prev.filter((id) => !visibleIds.includes(id)),
                    );
                  } else {
                    setSelectedColors((prev) => [
                      ...new Set([...prev, ...visibleIds]),
                    ]);
                  }
                }}
              >
                {selectedColors.length === colors.length
                  ? "Deselect All"
                  : "Select All"}
              </Button>
            }
          >
            <Input
              placeholder="Search variants..."
              value={colorSearch}
              onChange={(e) => setColorSearch(e.target.value)}
              style={{ marginBottom: 10 }}
            />

            <Space direction="vertical" style={{ width: "100%" }}>
              {displayedColors.map((c) => (
                <Checkbox
                  key={c.id}
                  checked={selectedColors.includes(c.id)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedColors((prev) => [
                        ...new Set([...prev, c.id]),
                      ]);
                    } else {
                      setSelectedColors((prev) =>
                        prev.filter((id) => id !== c.id),
                      );
                    }
                  }}
                >
                  {c.value}
                </Checkbox>
              ))}
            </Space>
          </Card>
        </Col>
      </Row>

      <Button type="primary" htmlType="submit" style={{ marginTop: 20 }}>
        Generate Products
      </Button>
    </Form>
  );
}
